<p-table #tableCustomersList dataKey="i" [value]="permissions" [lazy]="true" (onLazyLoad)="loadPermissions($event)"
	[paginator]="true" [totalRecords]="totalRecords" [loading]="permissionsLoading" [rows]="pageSize"
	[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
	sortField="End" [sortOrder]="-1" responsiveLayout="stack">

	<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
		<tr>
			<th style="width: 3rem;">
			</th>
			<th>
				<div pSortableColumn="Name" class="flex align-items-center justify-content-center">
					{{ 'CUSTOMER_NAME' | translate }}
					<p-sortIcon field="Name"></p-sortIcon>
				</div>
			</th>
			<th>
				<div pSortableColumn="Email" class="flex align-items-center justify-content-center">
					{{ 'EMAIL' | translate }}
					<p-sortIcon field="Email"></p-sortIcon>
				</div>
			</th>
			<th>
				<div pSortableColumn="Description" class="flex align-items-center justify-content-center">
					{{ 'DESCRIPTION' | translate }}
					<p-sortIcon field="Description"></p-sortIcon>
				</div>
			</th>
			<th>
				<div pSortableColumn="Start" class="flex align-items-center justify-content-center">
					{{ 'START_DATE' | translate }}
					<p-sortIcon field="Start"></p-sortIcon>
				</div>
			</th>
			<th>
				<div pSortableColumn="End" class="flex align-items-center justify-content-center">
					{{ 'END_DATE' | translate }}
					<p-sortIcon field="End"></p-sortIcon>
				</div>
			</th>
			<th>
				<div class="flex align-items-center justify-content-center">
					{{ 'STATUS' | translate }}
				</div>
			</th>
			<th>
				<div class="flex align-items-center justify-content-center">
					{{ 'VIEW_PIN' | translate }}
				</div>
			</th>
			<th>
				<div class="flex align-items-center justify-content-center">

				</div>
			</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-permission>
		<tr>
			<td>
				<span class="p-column-title font-semibold">{{ 'LANGUAGE' | translate }}</span>
				<div class="flex align-items-center justify-content-center"><img [src]="getCurrentLanguageFlag(permission.CustomerLanguage)" class="w-1_5rem"></div>
			</td>
			<td>
				<span class="p-column-title font-semibold">{{ 'CUSTOMER_NAME' | translate }}</span>
				<div class="flex align-items-center justify-content-center">{{ permission.Name | truncate:[50] }}</div>
			</td>
			<td>
				<span class="p-column-title font-semibold">{{ 'EMAIL' | translate }}</span>
				<div class="flex align-items-center justify-content-center">{{ permission.Email }}</div>
			</td>
			<td>
				<span class="p-column-title font-semibold">{{ 'DESCRIPTION' | translate }}</span>
				<div class="flex align-items-center justify-content-center">{{ permission.Description }}</div>
			</td>
			<td>
				<span class="p-column-title font-semibold">{{ 'START_DATE' | translate }}</span>
				<div class="flex align-items-center justify-content-center">{{ permission.Start | localizedDate: 'medium' }}
				</div>
			</td>
			<td>
				<span class="p-column-title font-semibold">{{ 'END_DATE' | translate }}</span>
				<div class="flex align-items-center justify-content-center"> {{ permission.End | localizedDate: 'medium' }}
				</div>
			</td>
			<td>
				<span class="p-column-title font-semibold">{{ 'STATUS' | translate }}</span>
				<p-tag [value]="permission.Status?.toUpperCase() | translate "
					[severity]="getColorStatus(permission.Status)">
				</p-tag>
			</td>
			<td>
				<span class="p-column-title font-semibold">{{ 'VIEW_PIN' | translate }}</span>
				<div class="flex align-items-center justify-content-around">
					<p-button id="buttonPermissionViewPin" pTooltip="{{ 'SEE_PIN' | translate }}" tooltipPosition="bottom"
						[icon]="!permission.PinVisible ? 'pi cm-eye' : 'pi cm-eye-not'" size="large"
						(click)="setVisiblePin(permission)" [rounded]="false" [text]="true" severity="secondary">
					</p-button>
					<div *ngIf="getVisiblePin(permission)">{{permission.PinCode}}</div>
					<div *ngIf="!getVisiblePin(permission)">•••••</div>
				</div>
			</td>
			<td>
				<span class="p-column-title"></span>
				<div class="flex flex-row justify-content-center align-items-center gap-1">
					<p-button id="buttonPermissionInfo" pTooltip="{{ 'INFO' | translate }}" tooltipPosition="bottom"
						icon="pi cm-info" size="large" (click)="info(permission)" [rounded]="false" [text]="true"
						severity="primary">
					</p-button>
					<p-button id="buttonPermissionEdit" pTooltip="{{ 'EDIT' | translate }}" tooltipPosition="bottom"
						icon="pi cm-pencil" size="large" (click)="editPermission(permission)" [rounded]="false" [text]="true"
						severity="secondary">
					</p-button>
					<p-button id="buttonPermissionReset" pTooltip="{{ 'RESET_PIN' | translate }}"
						[disabled]="expired(permission)" tooltipPosition="bottom" icon="pi cm-reload" size="large"
						(click)="resetPin(permission.Id)" [rounded]="false" [text]="true" severity="danger">
					</p-button>
					<p-button id="buttonPermissionDelete" pTooltip="{{ 'DELETE' | translate}}" tooltipPosition="bottom"
						icon="pi cm-trash" size="large" (click)="deletePer(permission)" [rounded]="false" [text]="true"
						severity="danger">
					</p-button>
				</div>
			</td>
		</tr>
	</ng-template>

	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
		</tr>
	</ng-template>
</p-table>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>